import script from "./StudentPaperView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentPaperView.vue?vue&type=script&setup=true&lang=ts"

import "./StudentPaperView.vue?vue&type=style&index=0&id=18af90c4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18af90c4"]])

export default __exports__